import {faPlus} from "@fortawesome/pro-solid-svg-icons/faPlus";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button, ColourSolid, FlexGap, StackVertical} from "@twigsby/frontend-framework";
import {useFieldArray, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useEffect} from "react";
import {RulesetFilterEntry} from "./RulesetFilterEntry";

export type RulesetFiltersType = {
    name: string;
    activeFilters: Array<number>;
    filterChangedCallback: (val: Array<number>) => void;
}

export const RulesetFilterList = [
    { label: 'Sender', value: 0 },
    { label: 'Received', value: 1 },
    { label: 'Recipient', value: 2 },
    { label: 'Mail Type', value: 3 },
    { label: 'In Folder', value: 4 },
    { label: 'Has Tag', value: 5 },
]

const RulesetFilters = (props: RulesetFiltersType) => {
    const { control, getValues } = useFormContext();

    const { fields, remove, append } = useFieldArray({
        control: control,
        name: props.name,
        shouldUnregister: true
    });

    const HandleFilterChange = () => {
        let activeIds: Array<number> = [];

        getValues(props.name)?.forEach((item: any) => !isNaN(item.id) ? activeIds.push(item.id) : null );

        props.filterChangedCallback(activeIds);
    }

    const MapFieldFilters = () => {
        getValues(props.name)?.map((filter: any) => {
            append(filter);
        })
    }

    useEffect(() => {
        if(fields.length === 0) {
            MapFieldFilters();
        }
    }, []);
    return (
        <StackVertical gap={FlexGap.Small}>
            {fields.map((field: any, fieldIndex: number) =>
                <RulesetFilterEntry
                    key={field.id}
                    field={field}
                    nameSlug={props.name}
                    fieldLength={fields.length}
                    fieldIndex={fieldIndex}
                    activeFilters={props.activeFilters}
                    addCallback={() => HandleFilterChange()}
                    removeCallback={() => {
                        remove(fieldIndex);
                        HandleFilterChange();
                    } }
                />
            )}

            {fields.length !== RulesetFilterList.length && (
                <div style={{ alignSelf: 'flex-start'}}>
                    <Button
                        title={'Add Criteria'}
                        squared={true}
                        colour={ColourSolid.Secondary}
                        icon={faPlus}
                        onClick={() => append({})}
                    />
                </div>
            )}
        </StackVertical>
    )
}

export { RulesetFilters }
